import { fetch } from 'whatwg-fetch';

export const get = (url, abortController = null) => _fetch(url, 'GET', null, abortController);

export const post = (url, data, abortController = null) => _fetch(url, 'POST', data, abortController);
export const put = (url, data, abortController = null) => _fetch(url, 'PUT', data, abortController);
export const patch = (url, data, abortController = null) => _fetch(url, 'PATCH', data, abortController);
export const remove = (url, data, abortController = null) => _fetch(url, 'DELETE', data, abortController);
export const resolveRequestVerificationToken = () => _resolveRequestVerificationToken();

const _resolveRequestVerificationToken = () => {
    let token = '';
    if (window.__litium && window.__litium.requestVerificationToken) {
        token = window.__litium.requestVerificationToken;
    }

    if (!token) {
        const tokenInput = document.querySelector('input[name="__RequestVerificationToken"]');
        if (tokenInput && tokenInput.value) {
            token = tokenInput.value;
        }
    }

    return token;
};

const _fetch = (url, method, data = null, abortController = null) => {
    const baseOptions = {
        method,
        headers: {
            'litium-request-context': JSON.stringify(window.__litium.requestContext),
        },
        credentials: 'include',
    };

    const buildOptions = (tokenOverride = null) => {
        let options = {
            ...baseOptions,
            headers: {
                ...baseOptions.headers,
            },
        };

        if (abortController) {
            options.signal = abortController.signal;
        }

        if (method !== 'GET') {
            options = {
                ...options,
                body: data ? JSON.stringify(data) : null,
                headers: {
                    ...options.headers,
                    'content-type': 'application/json',
                },
            };

            const token = tokenOverride || _resolveRequestVerificationToken();
            if (token) {
                options = {
                    ...options,
                    headers: {
                        ...options.headers,
                        RequestVerificationToken: token,
                    },
                };
            }
        }

        return options;
    };

    // use native browser implementation if it supports aborting
    const abortableFetch = 'signal' in new Request('') ? window.fetch : fetch;
    const initialOptions = buildOptions();
    return abortableFetch(url, initialOptions)
        .then(async (response) => {
            if (method === 'GET' || response.status !== 400) {
                return _checkStatus(response, { method, url });
            }

            const latestToken = (window.__litium && window.__litium.requestVerificationToken)
                ? window.__litium.requestVerificationToken
                : '';
            const currentToken = initialOptions.headers?.RequestVerificationToken || '';
            if (!latestToken || latestToken === currentToken) {
                return _checkStatus(response, { method, url });
            }

            const retryResponse = await abortableFetch(url, buildOptions(latestToken));
            return _checkStatus(retryResponse, { method, url });
        });
};

const _checkStatus = (response, requestMeta = {}) => {
    if (response.status >= 200 && response.status < 300) {
        return response;
    } else {
        if (typeof window !== 'undefined' &&
            window.__litium &&
            typeof window.__litium.reportHttpError === 'function') {
            try {
                window.__litium.reportHttpError({
                    url: requestMeta.url || response.url || '',
                    method: requestMeta.method || '',
                    status: response.status,
                    statusText: response.statusText || '',
                });
            } catch (reportError) {
                // Ignore client-side error reporting failures.
            }
        }

        let error = new Error(response.statusText);
        error.response = response;
        throw error;
    }
};
